// Authenticated fetch helper for admin endpoints.
// On 401 (except /admin/login and /admin/refresh), attempts ONE silent refresh
// via /api/admin/refresh and retries the request. If refresh also fails,
// redirects to /admin/login.

import { API_BASE } from './apiBase';

const BACKEND_URL = API_BASE;

let refreshInFlight = null;

async function refreshOnce() {
  if (refreshInFlight) return refreshInFlight;
  refreshInFlight = fetch(`${BACKEND_URL}/api/admin/refresh`, {
    method: 'POST',
    credentials: 'include',
  })
    .then((r) => r.ok)
    .catch(() => false)
    .finally(() => {
      // Allow a fresh refresh after the current one resolves
      setTimeout(() => {
        refreshInFlight = null;
      }, 1000);
    });
  return refreshInFlight;
}

export async function adminFetch(input, init = {}) {
  const url = typeof input === 'string' ? input : input.url;
  const opts = {
    credentials: 'include',
    ...init,
    headers: {
      ...(init.headers || {}),
    },
  };

  // First attempt
  let res = await fetch(input, opts);

  // Skip retry for login/refresh themselves
  const skipRetry =
    url.includes('/api/admin/login') || url.includes('/api/admin/refresh') || url.includes('/api/admin/logout');

  if (res.status === 401 && !skipRetry) {
    const refreshed = await refreshOnce();
    if (refreshed) {
      res = await fetch(input, opts);
    } else {
      // Refresh failed — kick to login ONLY if user is inside an admin route.
      // Public pages (/, /book-appointment, /doctors, etc.) must NEVER be hijacked
      // even if the AuthContext silently checks /api/admin/me on mount.
      if (
        typeof window !== 'undefined' &&
        window.location.pathname.startsWith('/admin') &&
        !window.location.pathname.startsWith('/admin/login')
      ) {
        window.location.href = '/admin/login';
      }
    }
  }

  return res;
}

export default adminFetch;
